var map = {
	"./align_flags.json": 959,
	"./bible_tgdaya_nt.json": 636,
	"./bible_tgdaya_ot.json": 777,
	"./bible_truku_nt.json": 401,
	"./bible_truku_ot.json": 316,
	"./dict_tgdaya.json": 807,
	"./dict_tgdaya_bible.json": 630,
	"./dict_toda.json": 553,
	"./dict_truku.json": 556,
	"./dict_truku_bible.json": 253,
	"./glosses.json": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;